import { useState, useRef, useEffect } from 'react'
import { Form } from 'react-bootstrap'

export default function FlexportMilestoneSelector({ milestones, onSelect, content }) {
  const [inputValue, setInputValue] = useState(content)
  const [filtered, setFiltered] = useState(milestones)
  const [showDropdown, setShowDropdown] = useState(false)

  const wrapperRef = useRef(null)

  useEffect(() => {
    // Close dropdown if clicked outside
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowDropdown(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => { document.removeEventListener("mousedown", handleClickOutside) }
  }, [])

  useEffect(() => {
    if (inputValue.trim() === '') {
      setFiltered(milestones)
    } else {
      const lowered = inputValue.toLowerCase()
      setFiltered(
        milestones.filter(p => p.description.toLowerCase().includes(lowered) || p.type.toLowerCase().includes(lowered))
      )
    }
  }, [inputValue, milestones])

  function handleSelect(milestone) {
    setInputValue(milestone.type)
    setShowDropdown(false)
    if(onSelect) onSelect(milestone.type)
  }

  return (
    <div style={{ position: 'relative' }} ref={wrapperRef}>
      <Form.Control
        placeholder="Enter a milestone..."
        value={inputValue}
        onChange={e => {
          setInputValue(e.target.value);
          setShowDropdown(true);
        }}
        onFocus={() => setShowDropdown(true)}
        autoComplete="off"
        style={{fontSize: '1.5rem'}}
      />
      {showDropdown && filtered.length > 0 && (
        <div style={{
          position: 'absolute',
          zIndex: 1000,
          backgroundColor: 'white',
          border: '1px solid #ccc',
          width: '100%',
          maxHeight: 300,
          overflowY: 'auto',
          cursor: 'pointer'
        }}>
          {filtered.map(product => (
            <div
              key={product.type}
              onClick={() => handleSelect(product)}
              style={{ padding: '5px 10px' }}
              onMouseDown={e => e.preventDefault()} // prevent blur
            >
              <span className='beacon-header'><code>{product.type}</code></span> - <span className='beacon-label'>{product.description}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}